import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { SharedModule } from '@tv3/shared/shared.module'
import { DataDictionaryDialogComponent } from '@tv3/shared/data-dictionary-dialog/data-dictionary-dialog.component'

@Injectable({
  providedIn: SharedModule,
})
export class DataDictionaryDialogService {
  constructor(private dialog: MatDialog) {}

  public open(branding?: boolean) {
    const defaultConfig: MatDialogConfig = {
      width: '850px',
      height: '500px',
      data: {
        branding,
      },
      panelClass: ['variable-modal'],
    }

    return this.dialog.open(DataDictionaryDialogComponent, defaultConfig).afterClosed()
  }
}
